module.exports = __webpack_public_path__ + "img/black-condensen-white-bg.35621802.png";